import React from 'react';
import Employee from '../Employee';
import IEmployee from '../models/IEmployee';

export interface IEmployeeGridProps {
    employees: IEmployee[];
}

export default function EmployeeGrid({ employees }: IEmployeeGridProps) {
    return (
        <div className="row">
            {employees.map(employee => (
                <Employee key={employee.name} {...employee} />
            ))}
        </div>
    );
}
